module.exports = __webpack_public_path__ + "img/9791190292061.e7d2ae4c.jpg";